<script setup>
import { computed } from 'vue';
import { useTrackingStore } from '@/stores/tracking';
import { Button, Menu } from '@dashhudson/dashing-ui';
import cloneDeep from 'lodash/cloneDeep';

const trackingStore = useTrackingStore();

const props = defineProps({
  menuItems: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  placement: {
    type: String,
    default: 'bottom-end',
  },
});

const menuModelItems = computed(() => {
  const menuItems = cloneDeep(props.menuItems);
  return menuItems.map((option) => ({
    ...option,
    icon: 'download',
    command: () => {
      trackingStore.track('File Downloaded', {
        FileType: option?.fileType,
        FileName: option?.fileName || option.label,
      });
      option.command();
    },
  }));
});
</script>

<template>
  <Menu :model="menuModelItems" :dropdown="{ placement }">
    <Button
      size="lg"
      icon="download"
      :loading="loading"
      :disabled="loading"
      data-test="DownloadReportDropdown"
    />
  </Menu>
</template>
